import {
    FormControlLabel,
    Radio,
    RadioGroup
} from '@mui/material/';
// import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
// import Tab from '@mui/material/Tab';
// import Tabs from '@mui/material/Tabs';
// import Typography from '@mui/material/Typography';
// import { useTheme, styled } from '@mui/material/styles';
import React, { useContext,useState } from 'react';
// import SwipeableViews from 'react-swipeable-views';
import CategoricalAnalysisGraph from './CategoricalAnalysisGraph';
import MultiVariantAnalysisGraph from './MultiVariantAnalysisGraph';
import UnivariateAnalysisGraph from './UnivariateAnalysisGraph';
import { SystemContext } from '../context';
import Alert from '@mui/material/Alert';
import './Tabs.css';



const DataVisualizationTabs_new = ({ fetchAPI }) => {
    const [activeTab, setActiveTab] = useState(1);
    const [value, setValue] = React.useState(0);

    const switchTab = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const { rawOrCleanData, setRawOrCleanData, cleanFlag } = useContext(SystemContext);

    const handleRawCleanData = (event) => {
        setRawOrCleanData(event.target.value)
    }

    return (
        <>
            <Box sx={{ bgcolor: 'background.paper', width: '98%',height:'100%' }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1rem' }}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        style={{ marginLeft: '1rem' }}
                        onChange={handleRawCleanData}
                        value={rawOrCleanData}
                    >
                        <FormControlLabel value="raw" control={<Radio />} label="Raw Data" />
                        <FormControlLabel value="clean" control={<Radio />} label="Clean Data" />

                    </RadioGroup>
                </div>
                <div className="container">
                    {/* Tabs */}
                    <div className="bloc-tabs">
                        <div
                            className={activeTab === 1 ? "tabs active-tabs" : "tabs"}
                            onClick={() => switchTab(1)}
                        >
                            Univariate Analysis
                        </div>
                        <div
                            className={activeTab === 2 ? "tabs active-tabs" : "tabs"}
                            onClick={() => switchTab(2)}
                        >
                            Categorical Analysis
                        </div>
                        <div
                            className={activeTab === 3 ? "tabs active-tabs" : "tabs"}
                            onClick={() => switchTab(3)}
                        >
                            Multi Variate Analysis
                        </div>
                    </div>

                    {/* Content */}
                    <div className="content-tabs">
                        <div className={activeTab === 1 ? "content active-content" : "content"}>
                            <div style={{ display: 'flex', width: '100%', height:'100vw',flexDirection: 'column', overflowY: 'auto' }}>
                                <UnivariateAnalysisGraph fetchAPI={fetchAPI} />

                            </div>
                            {
                                !cleanFlag && rawOrCleanData == "clean" &&
                                // <p style={{color:'red'}}>Please perform the data clean operation which is available in Upload & Process tab</p>
                                <Alert severity="warning" style={{ width: "35%", marginTop: "4%", marginLeft: "25%", backgroundColor: "lightyellow" }}>Cleaned data is not available, please perform Data cleaning !!!</Alert>
                            }

                        </div>
                        <div className={activeTab === 2 ? "content active-content" : "content"}>
                            <div style={{ display: 'flex', width: '100%',height:'100vw', flexDirection: 'column', overflowY: 'auto' }}>
                                <CategoricalAnalysisGraph fetchAPI={fetchAPI} />
                            </div>
                        </div>
                        <div className={activeTab === 3 ? "content active-content" : "content"}>
                            <div style={{ display: 'flex', width: '100%',height:'100vw', flexDirection: 'column', overflowY: 'auto' }}>
                                <MultiVariantAnalysisGraph fetchAPI={fetchAPI} />
                            </div>
                        </div>
                    </div>
                </div>

            </Box>
        </>
    );
}

export default DataVisualizationTabs_new;